export default () => {
	return `

vec2 highLowEncode(float value) {
	float high = floor(value * 256.0); // Extracts the most significant bits
	float low = fract(value * 256.0) * 256.0; // Extracts the least significant bits after the decimal

	// The 'high' and 'low' can then be written into separate color channels
	// For example:
	return vec2(high / 255.0, low / 255.0); // Normalize back to [0.0, 1.0] for storage in texture
}

float highLowDecode(vec2 encodedValue) {
	return (encodedValue.r * 255.0 + encodedValue.g) / 256.0;
}

// 1.0 inside the [0, 1] uv range, 0.0 outside. Used so clamped texture edges don't smear off screen
float insideUv(vec2 uv) {
	vec2 inside = step(vec2(0.0), uv) * step(uv, vec2(1.0));
	return inside.x * inside.y;
}

`}
